import { BriefingPeriod } from './market-briefing-types';

export interface AudioPlayerState {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  playbackRate: number;
}

export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2] as const;
export type PlaybackRate = typeof PLAYBACK_RATES[number];

export const PERIOD_BADGES: Record<BriefingPeriod, { label: string; gradient: string }> = {
  morning: {
    label: 'Morning Joe',
    gradient: 'bg-gradient-to-r from-[#ff9a56] to-[#ffcd67]'
  },
  midday: {
    label: 'Midday Madness',
    gradient: 'bg-gradient-to-r from-[#56ccf2] to-[#2f80ed]'
  },
  evening: {
    label: 'Evening Glory',
    gradient: 'bg-gradient-to-r from-[#667eea] to-[#764ba2]'
  }
};
